import { parseParameters } from "@otto-ec/global-resources/attribute-parser";
import { sheetCreate, sheetOpenById } from "./methods";
import { sheetTagName } from "../utils/consts";
import type { OcSheetV1Props } from "../SheetV1.types.g";
import { findInstance } from "../stack/stack.utils";
import { applyProps } from "../utils/props";

const API_PREFIX = `data-${sheetTagName}` as const;

export const TRIGGER_OPEN = "open";

export const TRIGGER_CREATE = "create";

export const TRIGGER_CLOSE = "close";

export const EVENT_CLICK = "click";

export const DATA_SHEET_OPEN = `${API_PREFIX}-${TRIGGER_OPEN}` as const;

export const DATA_SHEET_CREATE = `${API_PREFIX}-${TRIGGER_CREATE}` as const;

export const DATA_SHEET_CLOSE = `${API_PREFIX}-${TRIGGER_CLOSE}` as const;

export type OcSheetV1ConvenienceOptions = {
  container?: string;
  info?: unknown;
};

/**
 *
 *
 */
export const DATA_SHEET_OPEN_LEGACY = "data-oc-sheet-id";

type AsSelector<T extends string> = `[${T}]`;

/**
 *
 *
 */
export const DATA_SELECTORS = (
  [DATA_SHEET_OPEN, DATA_SHEET_CREATE, DATA_SHEET_OPEN_LEGACY, DATA_SHEET_CLOSE] as const
).map((s) => `[${s}]` as const) as [
  AsSelector<typeof DATA_SHEET_OPEN>,
  AsSelector<typeof DATA_SHEET_CREATE>,
  AsSelector<typeof DATA_SHEET_OPEN_LEGACY>,
  AsSelector<typeof DATA_SHEET_CLOSE>,
];

/**
 *
 *
 */
export function handleOpenOnClick(event: MouseEvent): void {
  const clickedElement = event.currentTarget as HTMLElement;
  const disabled = clickedElement.getAttribute("disabled");
  if (disabled) {
    return;
  }

  /*                            */
  const sheetID = clickedElement.getAttribute(DATA_SHEET_OPEN_LEGACY);
  if (sheetID) {
    sheetOpenById(sheetID);
    return;
  }

  const { info, ...config } = parseParameters<OcSheetV1Props & OcSheetV1ConvenienceOptions>(
    API_PREFIX,
    TRIGGER_OPEN,
    clickedElement,
  );
  if (!config.id) return;

  /*                                             */
  const sheetElement = findInstance(config.id);
  if (sheetElement) applyProps(sheetElement, config);

  /*                    */
  sheetOpenById(config.id, { info });
}

/**
 *
 *
 */
export function handleCreateOnClick(event: MouseEvent): void {
  const triggerElement = event.currentTarget as HTMLElement;

  const { container, info, ...config } = parseParameters<
    Omit<OcSheetV1Props & OcSheetV1ConvenienceOptions, "open">
  >(API_PREFIX, TRIGGER_CREATE, triggerElement);

  const containerElement = container && document.querySelector<HTMLElement>(container);

  let sheetElement: HTMLOcSheetV1Element;
  if (containerElement) {
    /*                                                                     */
    sheetElement = sheetCreate(config, { container: containerElement });
  } else {
    /*                                                                                   */
    const maybeSheetParent = triggerElement.closest(sheetTagName);

    /*                                                             */
    /*                                                     */
    sheetElement = sheetCreate(config, { adjacentElement: maybeSheetParent ?? triggerElement });
  }

  /*                                                                                           */
  triggerElement.setAttribute(`${DATA_SHEET_CREATE}.id`, sheetElement.id);

  /*                                  */
  sheetOpenById(sheetElement.id, { info });
}

/**
 *
 *
 */
export function handleCloseOnClick(event: MouseEvent): void {
  const clickedElement = event.currentTarget as HTMLElement;
  const disabled = clickedElement.getAttribute("disabled");
  if (disabled) {
    return;
  }

  const sheetElement = clickedElement.closest(sheetTagName) as HTMLOcSheetV1Element | null;
  if (!sheetElement) {
    if (import.meta.env.DEV)
      console.warn("Clicked close element is not inside a sheet instance", clickedElement);
    return;
  }

  const { info } = parseParameters<OcSheetV1Props & OcSheetV1ConvenienceOptions>(
    API_PREFIX,
    TRIGGER_CLOSE,
    clickedElement,
  );

  sheetElement.close({ info });
}
